document.addEventListener("DOMContentLoaded", function() {

    const toggleSectionsBtn = document.querySelectorAll(".js-toggle-sections");

    if(toggleSectionsBtn.length > 0){

        toggleSectionsBtn.forEach(function(el){

            const sections = el.closest(".block-catalog-sections");

            el.addEventListener("click", function(){

                sections.classList.add("opened");
            });

        });
    }

    if(window.innerWidth < 990){

        document.addEventListener("mouseup", function(e) {

            const $container = $(".js-catalog-sections");

            if (e.target != $container[0] && $container.has(e.target).length === 0
                && !e.target.classList.contains("js-toggle-sections")){

                $container.closest(".block-catalog-sections").removeClass("opened");
            }
        });
    }
});



